import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield } from 'lucide-react';

export const HeroSection = ({ openPopup }) => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1775046318523-b5227f41fe97)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#7C2D12]/95 via-[#7C2D12]/85 to-[#F97316]/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20">
            <Shield className="text-[#FED7AA] mr-2" size={20} />
            <span className="text-white text-sm font-medium">USPTO Filing Experts • 1000+ Trademarks Filed</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Protect Your Brand with{' '}
            <span className="text-[#FED7AA]">Professional</span>{' '}
            Trademark Registration
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed max-w-2xl">
            Secure exclusive rights to your brand name, logo, and identity with expert USPTO trademark registration services. Trusted by businesses nationwide.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              onClick={openPopup}
              size="lg"
              className="bg-[#F97316] hover:bg-white hover:text-[#7C2D12] text-white px-8 py-6 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl group"
            >
              Register My Trademark
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            
            <Button 
              onClick={openPopup}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#7C2D12] px-8 py-6 text-lg font-semibold transition-all duration-300"
            >
              Free Consultation
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#FED7AA] mb-1">1000+</div>
              <div className="text-white/80 text-sm">Trademarks Filed</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#FED7AA] mb-1">95%</div>
              <div className="text-white/80 text-sm">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#FED7AA] mb-1">15+</div>
              <div className="text-white/80 text-sm">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#FED7AA] mb-1">24/7</div>
              <div className="text-white/80 text-sm">Expert Support</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FFF7ED] to-transparent z-10"></div>
    </section>
  );
};

export default HeroSection;
